import { Box, Skeleton } from '@mui/material';

import { SearchResultItemSkeleton } from '@/components/skeletons/common/SearchResultItemSkeleton';

const RESULT_COUNT = 8;
const SIDEBAR_COUNT = 4;

export function SearchPageSkeleton() {
  return (
    <Box sx={{ py: { xs: 2, sm: 3 }, width: '100%', px: { xs: 1.5, sm: 0 } }}>
      {/* Mobile search input skeleton */}
      <Box sx={{ mb: 3, display: { xs: 'block', md: 'none' } }}>
        <Skeleton variant="rounded" height={56} sx={{ borderRadius: 2 }} />
      </Box>

      {/* Content area: main + sidebar */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          justifyContent: 'space-between',
          gap: { xs: 3, md: 2 },
          minHeight: { xs: 'auto', lg: '30rem' },
        }}
      >
        {/* Main content column */}
        <Box
          sx={{
            width: { xs: '100%', lg: '70%' },
            height: { xs: 'auto', lg: '40rem' },
            overflowY: 'auto',
            pr: { lg: 2 },
          }}
        >
          {/* Results header skeleton */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 4,
              mt: { xs: 2, lg: 0 },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
              <Skeleton variant="text" sx={{ width: 5, height: 5 }} />
              <Skeleton variant="text" sx={{ width: 11, height: 5 }} />
              <Skeleton variant="text" sx={{ width: 15, height: 5 }} />
            </Box>
            <Skeleton variant="rounded" sx={{ width: 5, height: 5, borderRadius: 1.25 }} />
          </Box>

          {/* Result list */}
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {Array.from({ length: RESULT_COUNT }).map((_, i) => (
              <SearchResultItemSkeleton key={i} />
            ))}
          </Box>
        </Box>

        {/* Sidebar skeleton */}
        <Box
          sx={{
            width: { xs: '100%', lg: '28%' },
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
          }}
        >
          <Skeleton variant="text" sx={{ width: '50%', height: 3.5, mb: 0.5 }} />
          {Array.from({ length: SIDEBAR_COUNT }).map((_, i) => (
            <Skeleton key={i} variant="rounded" sx={{ height: 7, borderRadius: 1.25 }} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
